import { storage } from '../firebase'


export const deleteFilesByPath = filesLinkArr => {
    let result = ''
    filesLinkArr.forEach(fileLink => {
        const fileRef = storage.ref(fileLink)
        fileRef.delete()
        .then(() => {
            result = 'success'
        })
        .catch((error) => {
            console.error('Fehler beim Löschen:', error);
            result = 'error'
        })
    })
    return result
}
/*
const getImgURL = (htmlText) => {
  
    const parser = new DOMParser()
    const doc = parser.parseFromString(htmlText, 'text/html')
    const img = doc.querySelector('img')
    const imageUrl = img?.getAttribute('src')
    return imageUrl
}
*/

const extractRef = (fileUrl) =>{
    const url = new URL(fileUrl);
    const path = decodeURIComponent(url.pathname.split('/o/')[1]);
    return path
}

export const deleteFileByUrl = url => {
    let result = ''
    const filePath = extractRef(url)
    const fileRef = storage.ref(filePath)
    fileRef.delete()
    .then(() => {
        result = 'success'
    })
    .catch((error) => {
        console.error('Fehler beim Löschen:', error);
        result = 'error'
    })
    return result
}